import Helmet from 'react-helmet'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import FlashConnector from './FlashConnector'
import AskRosieButton from 'components/AskRosie/AskRosieButton'
import { isWebviewSelector } from 'selectors'
import { shouldShowAskRosie } from 'util/chatSubject'
import styled from 'styled-components'

const FlashStickyWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 100000000;
`

const AskRosieFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.2rem 0 calc(1.2rem + env(safe-area-inset-bottom));
`

const Indicator = styled.div`
  position: sticky;
  bottom: 0px;
  display: flex;
  justify-content: center;

  span {
    background: ${(props) => props.theme.colors.infoDark};
    color: ${(props) => props.theme.colors.infoLighter};
    padding: 2px 4px;
    display: inline-block;
    border-radius: 4px 4px 0 0;
    font-size: 12px;
  }
`

const ShowIndicator = () => {
  if (import.meta.env.REACT_APP_BASENAME) {
    const parts = import.meta.env.REACT_APP_BASENAME.split('-')
    parts.shift()
    let feature = parts.join('-')
    if (sessionStorage.getItem('api-base')) feature = `${feature}|BE*`
    return (
      <Indicator>
        <span>{feature}</span>
      </Indicator>
    )
  }
  return null
}

const WebviewLayout = (props: { children: any }) => {
  const isLocked = useSelector<any, boolean>((state) => state.isLocked)
  const { isWebview } = useSelector(isWebviewSelector)
  const { pathname } = useLocation()
  const showAskRosie = !isLocked && isWebview && shouldShowAskRosie(pathname)

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      </Helmet>
      <div>
        <FlashStickyWrapper>
          <FlashConnector />
        </FlashStickyWrapper>
        {props.children}
        {showAskRosie && (
          <AskRosieFooter>
            <AskRosieButton />
          </AskRosieFooter>
        )}
      </div>
      <ShowIndicator />
    </>
  )
}

export default WebviewLayout
